import { Status, PaymentMethod } from '../types'

export function getStatusColor(status: Status): string {
  switch (status) {
    case 'Started':
      return 'bg-blue-100 text-blue-700 hover:bg-blue-200'
    case 'In Process':
      return 'bg-amber-100 text-amber-700 hover:bg-amber-200'
    case 'Validated & Locked':
      return 'bg-green-100 text-green-700 hover:bg-green-200'
    case 'Sent to LO for Validation':
      return 'bg-orange-100 text-orange-700 hover:bg-orange-200'
    case 'Pending Revision':
      return 'bg-purple-100 text-purple-700 hover:bg-purple-200'
    case 'Pending Level 2 Sign-off':
      return 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'
    case 'Pending Payment':
      return 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
    case 'Paid by ACH':
    case 'Paid by Check':
    case 'Paid by Wire':
      return 'bg-emerald-700 text-white hover:bg-emerald-800'
    default:
      return 'bg-slate-100 text-slate-600 hover:bg-slate-200'
  }
}

export function getPaymentMethodColor(method: PaymentMethod): string {
  switch (method) {
    case 'Wire':
      return 'bg-green-100 text-green-700 hover:bg-green-200'
    case 'ACH':
      return 'bg-blue-100 text-blue-700 hover:bg-blue-200'
    case 'Check':
      return 'bg-teal-100 text-teal-700 hover:bg-teal-200'
    default:
      return 'bg-slate-100 text-slate-600 hover:bg-slate-200'
  }
}
